import { useMemo } from 'react';
import { themeController } from './themeController';
import { useTheme } from './useTheme';

// Compatibility API for existing controls; shares the same state as useTheme.
export default function useDarkMode() {
  const { theme } = useTheme();
  return useMemo(
    () => ({
      isDarkMode: theme === 'dark',
      toggle: themeController.toggle,
      enable: themeController.enable,
      disable: themeController.disable,
    }),
    [theme],
  );
}
